module.exports = __webpack_public_path__ + "304f6bcdaaaee8e68c862c53fb78c6b9.svg";